import {
  createHttpPlatformClient,
  OktonPlatformClient,
  OktonSystemDefinition,
} from '@okton/platform-ui';

export const integraSystem: OktonSystemDefinition = {
  id: process.env.REACT_APP_PLATFORM_SYSTEM_ID || 'integra',
  name: 'Integra',
};

export const platformBaseUrl =
  process.env.REACT_APP_PLATFORM_API_URL ||
  'https://keycloak.okton.com.br/platform-api';

export const platformTokenKey = `@okton:auth:${integraSystem.id}:access_token`;

const rawClient = createHttpPlatformClient({
  baseUrl: platformBaseUrl,
  systemId: integraSystem.id,
});

async function safe<T>(promise: Promise<T>, fallback: T): Promise<T> {
  try {
    return await promise;
  } catch {
    return fallback;
  }
}

export const platformClient: OktonPlatformClient = {
  ...rawClient,
  getApplications: () => safe(rawClient.getApplications(), []),
  getFavorites: () => safe(rawClient.getFavorites(), []),
  getNavigation: systemId =>
    safe(rawClient.getNavigation?.(systemId) ?? Promise.resolve([]), []),
  search: query => safe(rawClient.search(query), []),
  getPreferences: () =>
    safe(rawClient.getPreferences?.() ?? Promise.resolve({}), {}),
  getBusinessContext: systemId =>
    safe(
      rawClient.getBusinessContext?.(systemId) ?? Promise.resolve(undefined),
      undefined,
    ),
};

export function syncPlatformToken(token?: string | null): void {
  if (token) {
    sessionStorage.setItem(platformTokenKey, token);
  } else {
    sessionStorage.removeItem(platformTokenKey);
  }
}
